/* tslint:disable */
/* eslint-disable */
/**
 * users
 * users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateCurrentUserPylonUnreadBaseline200Response
 */
export interface UpdateCurrentUserPylonUnreadBaseline200Response {
    /**
     * 
     */
    success?: boolean;
}

/**
 * Check if a given object implements the UpdateCurrentUserPylonUnreadBaseline200Response interface.
 */
export function instanceOfUpdateCurrentUserPylonUnreadBaseline200Response(value: object): value is UpdateCurrentUserPylonUnreadBaseline200Response {
    return true;
}

export function UpdateCurrentUserPylonUnreadBaseline200ResponseFromJSON(json: any): UpdateCurrentUserPylonUnreadBaseline200Response {
    return UpdateCurrentUserPylonUnreadBaseline200ResponseFromJSONTyped(json, false);
}

export function UpdateCurrentUserPylonUnreadBaseline200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateCurrentUserPylonUnreadBaseline200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
    };
}

export function UpdateCurrentUserPylonUnreadBaseline200ResponseToJSON(json: any): UpdateCurrentUserPylonUnreadBaseline200Response {
    return UpdateCurrentUserPylonUnreadBaseline200ResponseToJSONTyped(json, false);
}

export function UpdateCurrentUserPylonUnreadBaseline200ResponseToJSONTyped(value?: UpdateCurrentUserPylonUnreadBaseline200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
    };
}

